<script>
import Nav from "@/components/Nav/index.vue";
import { nextTick } from "vue";
import axios from "axios";
export default {
    name: "Edit",
    data() {
        return {
            isLock: true,
            isWrong: false,
            isBind: false,
            error03: false,
            maxDate: '',
            birthdayLock: false,
            inputData: {
                phone: '',
                name: '',
                birthday: '',
                gender: '',
                email: ''
            },
            originalData: {
                name: '',
                birthday: '',
                gender: '',
                email: ''
            },
        };
    },
    components: {
        Nav,
    },
    computed: {
        userNbInfo() {
            return this.$store.state.userNbInfo;
        },
        userLineInfo() {
            return this.$store.state.userLineInfo;
        },
        hostUrl() {
            return this.$store.state.hostUrl;
        },
    },
    watch: {
        inputData: {
            deep: true,
            handler(val) {
                const o = this.originalData;
                this.isLock = val.name === o.name &&
                    val.birthday === o.birthday &&
                    val.gender === o.gender &&
                    val.email === o.email;
            }
        }
    },
    mounted() {
        nextTick(() => {});
        const today = new Date()
        const format = d => d.toISOString().split('T')[0]
        this.maxDate = format(today)
        console.log(this.userNbInfo)
        this.inputData.phone = this.userNbInfo.data.user.phone
        this.inputData.name = this.userNbInfo.data.user.name
        this.inputData.birthday = this.userNbInfo.data.user.birthday?.replace(/\//g, '-')
        this.inputData.gender = this.userNbInfo.data.user.gender
        this.inputData.email = this.userNbInfo.data.user.email
        this.originalData = {
            name: this.inputData.name,
            birthday: this.inputData.birthday,
            gender: this.inputData.gender,
            email: this.inputData.email,
        };
    },
    methods: {        
        checkInput() {
            const _this = this;
            console.log("checkInput");
            
            if (!_this.inputData.name || _this.inputData.name === "") {
                alert("請輸入姓名");
                return;
            }

            if (_this.inputData.gender === "") {
                alert("請選擇性別");
                return;
            }

            if (!_this.inputData.birthday || _this.inputData.birthday === "") {
                alert("請選擇生日");
                return;
            }

            const min = '1900-01-01'
            const max = new Date().toISOString().split('T')[0]
            if (_this.inputData.birthday < min || _this.inputData.birthday > max) {
                alert('請輸入有效的出生日期（需介於 1900 年至今日之間）。')
                _this.inputData.birthday = '';
                return;
            }

            // _this.inputData.dateReplace = _this.inputData.birthday.replace(/-/g, "/");
            _this.sendSignUp();
        },
        sendSignUp() {
            console.log('edit')
            const _this = this;
            _this.$store.commit("loadingToggle", true);
            _this.isLock = true;

            const data = {
                name: _this.inputData.name,
                birthday: _this.inputData.birthday,
                gender: _this.inputData.gender,
                email: _this.inputData.email
            };

            axios
                .put(`${_this.hostUrl}member/profile`, 
                    data, 
                    {
                        headers: {
                            Authorization: `Bearer ${_this.$store.state.userNbInfo.access_token}`,
                            "Content-Type": "application/json"
                        }
                    })
                .then(response => {
                    console.log(response);

                    if (response.status === 200) {
                        const updatedUser = response.data.data.user;
                        _this.$store.commit("updateUserNBInfoUser", updatedUser);
                        _this.originalData = {
                            name: _this.inputData.name,
                            birthday: _this.inputData.birthday,
                            gender: _this.inputData.gender,
                            email: _this.inputData.email,
                        };
                        nextTick(() => {
                            _this.$store.commit("loadingToggle", false);
                        });
                    }
                })
                .catch(error => {
                    _this.isLock = false;
                    if (error.response.status === 400) {
                        if (error.response.data.error === "40002") {
                            _this.isWrong = true;
                        }
                    } else {
                        alert("伺服器忙碌中，請稍後再試");
                    }
                    console.log(error);
                });
        },
        validateEmail() {
            if (!this.inputData.email) return

            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

            if (!regex.test(this.inputData.email)) {
                alert('Email 格式不正確')
                this.inputData.email = ''
            }
        },
        limitWidth10() {
            const _this = this;
            let val = _this.inputData.name;
            let width = 0;
            let result = '';

            val = _this.removeLineBreaks(val)

            for (let ch of val) {
                const size = this.isHalfWidth(ch) ? 1 : 2;

                if (width + size > 10) break;

                width += size;
                result += ch;
            }

            _this.inputData.name = result;
        },
        isHalfWidth(ch) {
            return ch.codePointAt(0) <= 0x7F;
        },
        removeLineBreaks(str) {
            // 移除換行字元
            return str.replace(/[\r\n]+/g, '');
        },
        // testInput(){
        //     console.log([...this.inputData.name].map(c => c.charCodeAt(0)))
        // }
    },
};
</script>

<template src="./template.pug" lang="pug"></template>

<style src="./style.sass" lang="sass" scoped></style>
